import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=507adb48&"
import script from "./PaymentModal.vue?vue&type=script&lang=js&"
export * from "./PaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentModal.vue"
export default component.exports